import useFetchResource from 'hooks/useFetchResource';
import api from 'libs/api';
import { selectSerializer } from 'libs/serializers';

export interface ISpot {
  id: number;
  title: string;
  location: string;
}

export function useSpots(
  initialParams: { guid?: string; except_id?: number } = {},
  initialLoad = true
) {
  const { resource: spots, fetchResource: fetchSpots } = useFetchResource<ISpot[]>({
    api: initialParams.guid
      ? api.account.parking.public.spots.getAll
      : api.account.options.parkingSpots.getAll,
    initialValues: [],
    initialParams,
    initialLoad,
    serializer: (data) => selectSerializer(data.resources, { labelKey: 'title', valueKey: 'id' }),
  });

  return { spots, fetchSpots };
}
